import {
  type InfiniteData,
  type QueryFunctionContext,
  type UseInfiniteQueryResult,
  useInfiniteQuery,
} from '@tanstack/react-query';

import { engineService } from '@/services/engine-service';
import type { Automation } from '@/types/core/workflow-rule';
import type { Page } from '@/types/shared/page';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { engineQueryKeys } from './query-keys';

export function useListAutomations(
  tenantId: UUID,
  opts?: { limit?: number; next?: string; filter?: string }
): UseInfiniteQueryResult<InfiniteData<Page<Automation>, unknown>, Error> {
  return useInfiniteQuery<
    Page<Automation>,
    Error,
    InfiniteData<Page<Automation>, unknown>
  >({
    queryKey: engineQueryKeys.automationList(
      tenantId,
      opts?.limit,
      opts?.filter
    ),
    queryFn: (context: QueryFunctionContext) => {
      const pageParam = context.pageParam as string | undefined;
      return engineService.listAutomations(tenantId, {
        limit: opts?.limit,
        next: pageParam,
        filter: opts?.filter,
      });
    },
    enabled: !isEmptyUUID(tenantId),
    initialPageParam: opts?.next ?? undefined,
    getNextPageParam: (last) => last.next ?? undefined,
    getPreviousPageParam: (first) => first.prev ?? undefined,
  });
}
